import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_3 = {
  class: "data-table-shell"
};
const _hoisted_4 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_5 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "data-table-td"
};
const _hoisted_9 = {
  class: "font-medium text-slate-900"
};
const _hoisted_10 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_11 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_12 = {
  class: "data-table-td"
};
const _hoisted_13 = {
  class: "data-table-td is-right text-slate-600"
};
const _hoisted_14 = {
  class: "data-table-td"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_17 = ["title"];
const _hoisted_18 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_19 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "flex items-center gap-3"
};
const _hoisted_25 = {
  class: "min-w-0"
};
const _hoisted_26 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_27 = {
  key: 0,
  class: "flex min-h-[220px] items-center justify-center"
};
const _hoisted_28 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_29 = {
  class: "rounded-lg border border-slate-200 bg-slate-50 px-3 py-2"
};
const _hoisted_30 = {
  class: "flex items-center justify-between gap-3"
};
const _hoisted_31 = {
  class: "min-w-0"
};
const _hoisted_32 = {
  class: "mt-1 truncate text-base font-semibold text-slate-900"
};
const _hoisted_33 = {
  class: "mt-0.5 text-sm text-slate-500"
};
const _hoisted_34 = {
  key: 0,
  class: "rounded-lg border border-rose-200 bg-rose-50 px-4 py-4"
};
const _hoisted_35 = {
  key: 1,
  class: "rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-4"
};
const _hoisted_36 = {
  class: "flex items-center gap-3"
};
const _hoisted_37 = ["src"];
const _hoisted_38 = {
  key: 1,
  class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-slate-400 ring-1 ring-emerald-100"
};
const _hoisted_39 = {
  class: "min-w-0"
};
const _hoisted_40 = {
  class: "truncate text-base font-semibold text-slate-900"
};
const _hoisted_41 = {
  class: "mt-0.5 text-sm text-slate-600"
};
const _hoisted_42 = {
  key: 2,
  class: "rounded-lg border border-primary-200 bg-primary-50 px-4 py-4"
};
const _hoisted_43 = {
  class: "flex flex-col gap-3 sm:flex-row sm:items-center"
};
const _hoisted_44 = {
  class: "flex min-w-0 flex-1 items-center gap-3"
};
const _hoisted_45 = ["src"];
const _hoisted_46 = {
  key: 1,
  class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-slate-400 ring-1 ring-primary-100"
};
const _hoisted_47 = {
  class: "min-w-0"
};
const _hoisted_48 = ["title"];
const _hoisted_49 = ["title"];
const _hoisted_50 = ["disabled"];
const _hoisted_51 = {
  key: 3,
  class: "rounded-lg border border-slate-200 bg-white px-4 py-4"
};
const _hoisted_52 = {
  class: "flex flex-col-reverse gap-3 sm:flex-row sm:justify-end"
};
const _hoisted_53 = ["disabled"];
const _hoisted_54 = ["disabled"];
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getReferrerPage, updateReferrerStatus, deleteReferrer, bindAppUser, getReferrerAppUser, getReferrerAppUserCandidate, bindReferrerAppUserCandidate, unbindAppUser } from '@/api/referrer';
import { useUserStore } from '@/stores/user';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import ReferrerFormModal from '@/components/ReferrerFormModal.vue';
import ReferrerDetailModal from './components/ReferrerDetailModal.vue';
export default {
  __name: 'ReferrerManagement',
  setup(__props) {
    const userStore = useUserStore();

    // 引入人类型映射
    const referrerTypeMap = {
      '0': '渠道',
      '1': '客户转介绍',
      '2': '政府',
      '3': '其他'
    };
    const getReferrerTypeName = type => {
      return referrerTypeMap[type] || '-';
    };

    // 格式化时间
    const formatTime = time => {
      if (!time) return '-';
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    // 数据列表
    const list = ref([]);
    const loading = ref(false);
    const total = ref(0);

    // 查询参数
    const queryParams = reactive({
      id: null,
      name: '',
      phone: '',
      referrerType: '',
      status: ''
    });

    // 定位高亮的引入人ID（选择已有引入人后标记）
    const highlightedReferrerId = ref(null);

    // 分页
    const pagination = reactive({
      current: 1,
      size: 10,
      pages: 1
    });

    // 表单弹窗
    const formModalVisible = ref(false);
    const currentReferrer = ref(null);

    // 详情弹窗
    const detailModalVisible = ref(false);
    const currentReferrerId = ref(null);

    // 绑定APP用户弹窗
    const bindDialogVisible = ref(false);
    const bindLoading = ref(false);
    const bindSubmitLoading = ref(false);
    const bindFormRef = ref(null);
    const bindForm = reactive({
      referrerId: null,
      phone: ''
    });
    const bindFormRules = {
      phone: [{
        required: true,
        message: '请输入APP用户手机号',
        trigger: 'blur'
      }, {
        pattern: /^1[3-9]\d{9}$/,
        message: '请输入正确的手机号',
        trigger: 'blur'
      }]
    };
    const boundAppUser = ref(null);
    const appUserCandidate = ref(null);
    const bindStateLoadFailed = ref(false);

    // 计算可见页码

    // 加载数据
    const fetchData = async () => {
      loading.value = true;
      try {
        const params = {
          page: pagination.current,
          size: pagination.size,
          ...Object.fromEntries(Object.entries(queryParams).filter(([, v]) => v !== '' && v !== null && v !== undefined))
        };
        const data = await getReferrerPage(params);
        list.value = data.records || [];
        total.value = data.total || 0;
        pagination.pages = data.pages || 1;
      } catch (error) {
        console.error('获取引入人列表失败:', error);
        ElMessage.error(error.message || '获取引入人列表失败');
      } finally {
        loading.value = false;
      }
    };

    // 搜索
    const handleSearch = () => {
      pagination.current = 1;
      fetchData();
    };

    // 重置
    const handleReset = () => {
      queryParams.id = null;
      queryParams.name = '';
      queryParams.phone = '';
      queryParams.referrerType = '';
      queryParams.status = '';
      pagination.current = 1;
      fetchData();
    };

    // 分页
    const handlePageChange = page => {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      fetchData();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.current = 1;
      fetchData();
    };

    // 新增
    const handleAdd = () => {
      currentReferrer.value = null;
      formModalVisible.value = true;
    };

    // 编辑
    const handleEdit = item => {
      currentReferrer.value = {
        ...item
      };
      formModalVisible.value = true;
    };

    // 查看详情
    const handleViewDetail = item => {
      currentReferrer.value = {
        ...item
      };
      currentReferrerId.value = item.id;
      detailModalVisible.value = true;
    };
    const canOperateAppUserBinding = item => {
      const createUserId = item?.createUserId;
      const currentUserId = userStore.userInfo?.userId;
      if (createUserId === null || createUserId === undefined) return false;
      if (currentUserId === null || currentUserId === undefined) return false;
      return String(createUserId) === String(currentUserId);
    };

    // 删除
    const handleDelete = async item => {
      try {
        await ElMessageBox.confirm(`确定要删除引入人「${item.name}」吗？`, '删除确认', {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteReferrer(item.id);
        ElMessage.success('删除成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除引入人失败:', error);
          ElMessage.error(error.message || '删除引入人失败');
        }
      }
    };

    // 切换状态
    const handleToggleStatus = async item => {
      const newStatus = item.status === 1 ? 0 : 1;
      const statusText = newStatus === 1 ? '启用' : '禁用';
      try {
        await ElMessageBox.confirm(`确定要${statusText}引入人「${item.name}」吗？`, '状态切换', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await updateReferrerStatus(item.id, newStatus);
        ElMessage.success(`${statusText}成功`);
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('切换状态失败:', error);
          ElMessage.error(error.message || '切换状态失败');
        }
      }
    };
    const loadAppUserCandidate = async referrerId => {
      appUserCandidate.value = null;
      if (!referrerId) return;
      try {
        const data = await getReferrerAppUserCandidate(referrerId);
        appUserCandidate.value = data || null;
      } catch (error) {
        appUserCandidate.value = null;
        console.error('查询匹配APP用户失败:', error);
      }
    };
    const promptBindCandidateAfterCreate = async referrer => {
      if (!referrer?.id) return;
      let candidate = null;
      try {
        candidate = await getReferrerAppUserCandidate(referrer.id);
      } catch (error) {
        console.error('查询新建引入人匹配APP用户失败:', error);
        return;
      }
      if (!candidate) return;
      try {
        const candidateName = candidate.nickname || '未设置昵称';
        const candidatePhone = candidate.phone || referrer.phone || '-';
        await ElMessageBox.confirm(`检测到相同手机号的APP用户「${candidateName}」（${candidatePhone}），是否需要直接绑定？`, '绑定APP用户', {
          confirmButtonText: '直接绑定',
          cancelButtonText: '暂不绑定',
          type: 'info'
        });
        await bindReferrerAppUserCandidate(referrer.id);
        ElMessage.success('绑定成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          console.error('创建后快速绑定APP用户失败:', error);
          ElMessage.error(error.message || '绑定APP用户失败');
        }
      }
    };

    // 表单提交成功
    const handleFormSuccess = async event => {
      await fetchData();
      if (event?.action === 'create') {
        await promptBindCandidateAfterCreate(event?.referrer);
      }
    };

    // 选择已有引入人：关闭新增弹窗，按ID查询定位并高亮该记录
    const handleSelectExisting = async referrer => {
      if (!referrer?.id) return;
      formModalVisible.value = false;
      queryParams.id = referrer.id;
      queryParams.name = '';
      queryParams.phone = '';
      queryParams.referrerType = '';
      queryParams.status = '';
      pagination.current = 1;
      await fetchData();
      highlightedReferrerId.value = referrer.id;
      ElMessage.success(`已定位到已有引入人「${referrer.name}」，该引入人已存在，无需重复创建`);
      setTimeout(() => {
        if (highlightedReferrerId.value === referrer.id) {
          highlightedReferrerId.value = null;
        }
      }, 5000);
    };

    // 绑定APP用户
    const handleBindAppUserOpen = async item => {
      currentReferrer.value = {
        ...item
      };
      bindForm.referrerId = item.id;
      bindForm.phone = '';
      boundAppUser.value = null;
      appUserCandidate.value = null;
      bindStateLoadFailed.value = false;
      bindDialogVisible.value = true;
      bindLoading.value = true;
      try {
        const data = await getReferrerAppUser(item.id);
        boundAppUser.value = data || null;
        if (!boundAppUser.value && canOperateAppUserBinding(currentReferrer.value)) {
          await loadAppUserCandidate(item.id);
        }
      } catch (error) {
        boundAppUser.value = null;
        appUserCandidate.value = null;
        bindStateLoadFailed.value = true;
        console.error('获取APP用户绑定状态失败:', error);
        ElMessage.error('获取APP用户绑定状态失败，请稍后重试');
      } finally {
        bindLoading.value = false;
      }
    };
    const handleBindAppUser = async () => {
      if (!canOperateAppUserBinding(currentReferrer.value)) {
        ElMessage.error('只有创建人才能操作引入人APP用户绑定');
        return;
      }
      if (bindStateLoadFailed.value) {
        ElMessage.error('绑定状态加载失败，请关闭后重试');
        return;
      }
      const valid = await bindFormRef.value.validate().catch(() => false);
      if (!valid) return;
      bindSubmitLoading.value = true;
      try {
        await bindAppUser(currentReferrer.value.id, {
          referrerId: bindForm.referrerId,
          phone: bindForm.phone
        });
        ElMessage.success('绑定成功');
        bindDialogVisible.value = false;
        fetchData();
      } catch (error) {
        console.error('绑定APP用户失败:', error);
        ElMessage.error(error.message || '绑定APP用户失败');
      } finally {
        bindSubmitLoading.value = false;
      }
    };
    const handleBindAppUserCandidate = async () => {
      if (!currentReferrer.value?.id) return;
      if (!canOperateAppUserBinding(currentReferrer.value)) {
        ElMessage.error('只有创建人才能操作引入人APP用户绑定');
        return;
      }
      if (bindStateLoadFailed.value) {
        ElMessage.error('绑定状态加载失败，请关闭后重试');
        return;
      }
      bindSubmitLoading.value = true;
      try {
        await bindReferrerAppUserCandidate(currentReferrer.value.id);
        ElMessage.success('绑定成功');
        bindDialogVisible.value = false;
        fetchData();
      } catch (error) {
        console.error('快速绑定APP用户失败:', error);
        ElMessage.error(error.message || '快速绑定APP用户失败');
      } finally {
        bindSubmitLoading.value = false;
      }
    };
    const handleUnbindAppUser = async () => {
      if (!canOperateAppUserBinding(currentReferrer.value)) {
        ElMessage.error('只有创建人才能操作引入人APP用户绑定');
        return;
      }
      try {
        await ElMessageBox.confirm(`确定要解除「${currentReferrer.value?.name}」的APP用户绑定吗？`, '解除绑定', {
          confirmButtonText: '确定解除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await unbindAppUser(currentReferrer.value.id);
        ElMessage.success('解除绑定成功');
        boundAppUser.value = null;
        await loadAppUserCandidate(currentReferrer.value.id);
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('解除绑定失败:', error);
          ElMessage.error(error.message || '解除绑定失败');
        }
      }
    };

    // 初始化
    onMounted(() => {
      fetchData();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "引入人管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "维护引入人资料、类型和启用状态")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchData
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: handleAdd,
            class: "btn-primary"
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增引入人 ", -1)]))])), [[_directive_permission, 'referrer:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            onClick: handleSearch,
            class: "btn-primary"
          }, " 搜索 "), _createElementVNode("button", {
            onClick: handleReset,
            class: "btn-secondary"
          }, " 重置 ")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.name = $event),
            type: "text",
            placeholder: "搜索引入人姓名",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, queryParams.name]]), _cache[10] || (_cache[10] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.phone = $event),
            type: "text",
            placeholder: "搜索联系电话",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, queryParams.phone]]), _createVNode(_component_el_select, {
            modelValue: queryParams.referrerType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.referrerType = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "渠道",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "客户转介绍",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "政府",
              value: "2"
            }), _createVNode(_component_el_option, {
              label: "其他",
              value: "3"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: queryParams.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => queryParams.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "启用",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "禁用",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("table", _hoisted_5, [_cache[18] || (_cache[18] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "引入人姓名"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "联系电话"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "微信号"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "引入类型"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "累计客户数"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "备注"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [...(_cache[12] || (_cache[12] = [_createElementVNode("td", {
          colspan: "9",
          class: "data-table-td is-center"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center justify-center"
        }, [_createElementVNode("div", {
          class: "w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mb-3"
        }), _createElementVNode("span", {
          class: "text-slate-500"
        }, "加载中...")])], -1)]))])) : list.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[13] || (_cache[13] = [_createElementVNode("td", {
          colspan: "9",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        })]), _createElementVNode("span", null, "暂无数据")])], -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: _normalizeClass(['data-table-row', {
              'bg-amber-50': highlightedReferrerId.value === item.id
            }])
          }, [_createElementVNode("td", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1)]), _createElementVNode("td", _hoisted_10, _toDisplayString(item.phone), 1), _createElementVNode("td", _hoisted_11, _toDisplayString(item.wechat || '-'), 1), _createElementVNode("td", _hoisted_12, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium", {
              'status-badge is-info': item.referrerType === '0',
              'status-badge is-success': item.referrerType === '1',
              'status-badge is-purple': item.referrerType === '2',
              'status-badge is-neutral': item.referrerType === '3'
            }])
          }, _toDisplayString(item.referrerTypeName || getReferrerTypeName(item.referrerType)), 3)]), _createElementVNode("td", _hoisted_13, _toDisplayString(item.totalCustomerCount || 0), 1), _createElementVNode("td", _hoisted_14, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium cursor-pointer", {
              'status-badge is-success': item.status === 1,
              'status-badge is-danger': item.status === 0
            }]),
            onClick: $event => handleToggleStatus(item)
          }, _toDisplayString(item.statusName || (item.status === 1 ? '启用' : '禁用')), 11, _hoisted_15)]), _createElementVNode("td", _hoisted_16, _toDisplayString(formatTime(item.createTime)), 1), _createElementVNode("td", {
            class: "data-table-td text-slate-600 max-w-[200px] truncate",
            title: item.remark
          }, _toDisplayString(item.remark || '-'), 9, _hoisted_17), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
            onClick: $event => handleViewDetail(item),
            class: "table-action-button is-primary",
            title: "详情",
            "aria-label": "详情"
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_20), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleEdit(item),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_21)), [[_directive_permission, 'referrer:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleDelete(item),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_22)), [[_directive_permission, 'referrer:delete']]), _createElementVNode("button", {
            onClick: $event => handleBindAppUserOpen(item),
            class: "table-action-button is-primary",
            title: "绑定APP用户",
            "aria-label": "绑定APP用户"
          }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          })], -1)]))], 8, _hoisted_23)])])], 2);
        }), 128))])])])]), list.value.length > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": [10, 20, 50],
          "total-label": "共 ",
          "total-suffix": " 条引入人",
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(ReferrerFormModal, {
          visible: formModalVisible.value,
          "onUpdate:visible": _cache[4] || (_cache[4] = $event => formModalVisible.value = $event),
          "referrer-data": currentReferrer.value,
          onSuccess: handleFormSuccess,
          onSelectExisting: handleSelectExisting
        }, null, 8, ["visible", "referrer-data"]), _createVNode(ReferrerDetailModal, {
          visible: detailModalVisible.value,
          "onUpdate:visible": _cache[5] || (_cache[5] = $event => detailModalVisible.value = $event),
          "referrer-id": currentReferrerId.value,
          "referrer-info": currentReferrer.value
        }, null, 8, ["visible", "referrer-id", "referrer-info"]), _createVNode(_component_el_dialog, {
          modelValue: bindDialogVisible.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => bindDialogVisible.value = $event),
          width: "560px",
          "align-center": "",
          "close-on-click-modal": false
        }, _createSlots({
          header: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_cache[20] || (_cache[20] = _createElementVNode("div", {
            class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600 ring-1 ring-primary-100"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          })])], -1)), _createElementVNode("div", _hoisted_25, [_cache[19] || (_cache[19] = _createElementVNode("div", {
            class: "text-lg font-semibold leading-6 text-slate-900"
          }, "绑定APP用户", -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(bindStateLoadFailed.value ? '绑定状态加载失败' : boundAppUser.value ? '当前引入人已存在绑定关系' : '当前引入人尚未绑定APP用户'), 1)])])]),
          default: _withCtx(() => [bindLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[21] || (_cache[21] = [_createElementVNode("div", {
            class: "flex flex-col items-center gap-3 text-slate-500"
          }, [_createElementVNode("div", {
            class: "app-spinner"
          }), _createElementVNode("span", {
            class: "text-sm"
          }, "加载中...")], -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_cache[22] || (_cache[22] = _createElementVNode("div", {
            class: "text-xs font-medium uppercase text-slate-500"
          }, "引入人", -1)), _createElementVNode("div", _hoisted_32, _toDisplayString(currentReferrer.value?.name || '-'), 1), _createElementVNode("div", _hoisted_33, _toDisplayString(currentReferrer.value?.phone || '-'), 1)]), _createElementVNode("span", {
            class: _normalizeClass(["inline-flex shrink-0 items-center rounded-full px-2.5 py-1 text-xs font-medium", boundAppUser.value ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'])
          }, _toDisplayString(boundAppUser.value ? '已绑定' : '未绑定'), 3)])]), bindStateLoadFailed.value ? (_openBlock(), _createElementBlock("div", _hoisted_34, [...(_cache[23] || (_cache[23] = [_createElementVNode("div", {
            class: "flex items-start gap-3"
          }, [_createElementVNode("div", {
            class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white text-rose-600 ring-1 ring-rose-100"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v3.75m0 3.75h.007v.008H12v-.008zM10.29 3.86L1.82 18a1.5 1.5 0 001.29 2.25h17.78A1.5 1.5 0 0022.18 18L13.71 3.86a1.5 1.5 0 00-2.42 0z"
          })])]), _createElementVNode("div", {
            class: "min-w-0"
          }, [_createElementVNode("div", {
            class: "font-semibold text-rose-700"
          }, "绑定状态加载失败"), _createElementVNode("div", {
            class: "mt-1 text-sm text-rose-600"
          }, "无法确认当前引入人是否已有绑定，请关闭后重试。")])], -1)]))])) : boundAppUser.value ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_cache[25] || (_cache[25] = _createElementVNode("div", {
            class: "mb-3 flex items-center gap-2 text-sm font-medium text-emerald-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 已绑定用户 ")], -1)), _createElementVNode("div", _hoisted_36, [boundAppUser.value.avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: boundAppUser.value.avatar,
            class: "h-9 w-9 rounded-full object-cover ring-2 ring-white"
          }, null, 8, _hoisted_37)) : (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
            class: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)]))])), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(boundAppUser.value.nickname || '未设置昵称'), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(boundAppUser.value.phone), 1)])])])) : canOperateAppUserBinding(currentReferrer.value) && appUserCandidate.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[27] || (_cache[27] = _createElementVNode("div", {
            class: "mb-3 flex items-center justify-between gap-3"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-primary-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V6a4 4 0 118 0v1m-9 4h10m-8 4h6m-8 4h10a2 2 0 002-2V9a2 2 0 00-2-2H7a2 2 0 00-2 2v8a2 2 0 002 2z"
          })]), _createTextVNode(" 发现匹配用户 ")]), _createElementVNode("span", {
            class: "shrink-0 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-primary-700 ring-1 ring-primary-100"
          }, " 同手机号 ")], -1)), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [appUserCandidate.value.avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: appUserCandidate.value.avatar,
            class: "h-9 w-9 rounded-full object-cover ring-2 ring-white"
          }, null, 8, _hoisted_45)) : (_openBlock(), _createElementBlock("div", _hoisted_46, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
            class: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)]))])), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
            class: "truncate whitespace-nowrap text-base font-semibold text-slate-900",
            title: appUserCandidate.value.nickname || '未设置昵称'
          }, _toDisplayString(appUserCandidate.value.nickname || '未设置昵称'), 9, _hoisted_48), _createElementVNode("div", {
            class: "mt-0.5 truncate whitespace-nowrap text-sm text-slate-600",
            title: appUserCandidate.value.phone || '-'
          }, _toDisplayString(appUserCandidate.value.phone || '-'), 9, _hoisted_49)])]), _createElementVNode("button", {
            onClick: handleBindAppUserCandidate,
            class: "btn-primary shrink-0 self-stretch whitespace-nowrap sm:self-auto sm:min-w-[96px]",
            type: "button",
            disabled: bindSubmitLoading.value
          }, _toDisplayString(bindSubmitLoading.value ? '绑定中...' : '直接绑定'), 9, _hoisted_50)])])) : _createCommentVNode("", true), canOperateAppUserBinding(currentReferrer.value) && !boundAppUser.value && !bindStateLoadFailed.value ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_cache[28] || (_cache[28] = _createElementVNode("div", {
            class: "mb-3 flex items-center gap-2 text-sm font-medium text-slate-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4 text-slate-500",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7.5 8.25h9m-9 3.75h6m-6 3.75h9M5.25 4.5h13.5A1.5 1.5 0 0120.25 6v12a1.5 1.5 0 01-1.5 1.5H5.25A1.5 1.5 0 013.75 18V6a1.5 1.5 0 011.5-1.5z"
          })]), _createTextVNode(" 手动绑定 ")], -1)), _createVNode(_component_el_form, {
            ref_key: "bindFormRef",
            ref: bindFormRef,
            model: bindForm,
            rules: bindFormRules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "APP用户手机号",
              prop: "phone",
              class: "mb-0"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: bindForm.phone,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => bindForm.phone = $event),
                placeholder: "请输入APP用户手机号",
                maxlength: "11",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])])) : _createCommentVNode("", true)]))]),
          _: 2
        }, [!bindLoading.value ? {
          name: "footer",
          fn: _withCtx(() => [_createElementVNode("div", _hoisted_52, [_createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = $event => bindDialogVisible.value = false),
            class: "btn-secondary w-full sm:w-auto",
            type: "button"
          }, _toDisplayString(boundAppUser.value ? '关闭' : '取消'), 1), boundAppUser.value && canOperateAppUserBinding(currentReferrer.value) ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: handleUnbindAppUser,
            class: "btn-danger-secondary w-full sm:w-auto",
            type: "button",
            disabled: bindSubmitLoading.value
          }, " 解除绑定 ", 8, _hoisted_53)) : _createCommentVNode("", true), canOperateAppUserBinding(currentReferrer.value) && !boundAppUser.value && !bindStateLoadFailed.value ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: handleBindAppUser,
            class: "btn-primary w-full sm:w-auto",
            type: "button",
            disabled: bindSubmitLoading.value
          }, _toDisplayString(bindSubmitLoading.value ? '绑定中...' : '按手机号绑定'), 9, _hoisted_54)) : _createCommentVNode("", true)])]),
          key: "0"
        } : undefined]), 1032, ["modelValue"])]),
        _: 1
      });
    };
  }
};